// extracted by mini-css-extract-plugin
export default {"title":"Stories_title__Gy9sh","contentWrapper":"Stories_contentWrapper__lzQrV","stories":"Stories_stories__-tIxV","center":"Stories_center__tOJoN","story":"Stories_story__Zpg23"};